import { useDidMount } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

export const usePageContainerHelper = (): void => {
	useDidMount(() => {
		window.scrollTo(0, 0);
	});
};
